import React from "react";

/**
 * Material Symbols Outlined icon wrapper.
 * Usage: <Icon name="star" size={20} className="text-purple-400" />
 */
const Icon = ({ name, size = 20, className = "", style = {}, fill = false }) => (
  <span
    className={`material-symbols-outlined ${className}`}
    style={{
      fontSize: size,
      fontVariationSettings: fill ? "'FILL' 1" : "'FILL' 0",
      verticalAlign: "middle",
      lineHeight: 1,
      ...style,
    }}
  >
    {name}
  </span>
);

export default Icon;
